import { render, staticRenderFns } from "./EmoticonSelect.vue?vue&type=template&id=87c3628c&scoped=true&"
import script from "./EmoticonSelect.vue?vue&type=script&lang=js&"
export * from "./EmoticonSelect.vue?vue&type=script&lang=js&"
import style0 from "./EmoticonSelect.vue?vue&type=style&index=0&id=87c3628c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c3628c",
  null
  
)

export default component.exports